import { shareModalActionTypes } from './Constants';

export function toggleShareModal(data) {
	return {
		type: shareModalActionTypes.TOGGLE_SHARE_MODAL,
		payload: { data },
	};
}

export function getShareLink(data) {
	return {
		type: shareModalActionTypes.GET_SHARE_LINK,
		payload: { data },
	};
}

export function getShareLinkSuccess(data) {
	return {
		type: shareModalActionTypes.GET_SHARE_LINK_SUCCESS,
		payload: { data },
	};
}

export function getShareLinkError() {
	return {
		type: shareModalActionTypes.GET_SHARE_LINK_ERROR,
	};
}

export function clearShareModalState() {
	return {
		type: shareModalActionTypes.CLEAR_SHARE_MODAL_STATE,
	};
}
